import React from 'react';

function Router() {
	return null;
}

export default Router;